export const BANDEIRAS_CARTAO = {
  visa: { id: "visa", label: "Visa" },
  mastercard: { id: "mastercard", label: "Mastercard" },
  amex: { id: "amex", label: "American Express" },
  elo: { id: "elo", label: "Elo" },
  hipercard: { id: "hipercard", label: "Hipercard" },
  diners: { id: "diners", label: "Diners Club" },
};

const eloBins = [
  "4011",
  "4312",
  "4389",
  "4514",
  "4576",
  "5041",
  "5066",
  "5067",
  "5090",
  "6277",
  "6362",
  "6363",
  "6504",
  "6505",
  "6516",
];

export function detectarBandeiraCartao(numero) {
  const digits = String(numero || "").replace(/\D/g, "");
  if (digits.length < 2) return null;

  if (/^4/.test(digits)) return "visa";

  if (/^3[47]/.test(digits)) return "amex";

  if (/^36/.test(digits) || /^30[0-5]/.test(digits) || /^38/.test(digits)) return "diners";

  if (digits.startsWith("606282")) return "hipercard";

  if (eloBins.some((bin) => digits.startsWith(bin))) return "elo";

  const prefix2 = parseInt(digits.slice(0, 2), 10);
  const prefix4 = parseInt(digits.slice(0, 4), 10);
  if ((prefix2 >= 51 && prefix2 <= 55) || (prefix4 >= 2221 && prefix4 <= 2720)) {
    return "mastercard";
  }

  return null;
}
